var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.question.answers[0].body !== null)?_c('div',{staticClass:"file-question"},[_c('vcv-link',{attrs:{"text":_vm.$tr('responses.presentation.download'),"link":_vm.linkToFile}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }